import { h, resolveComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'

import auth from '@/middleware/auth'
import basePath from '@/basePath'

const routes = [
  {
    path: basePath + 'login',
    name: 'CompanyLogin',
    component: () => import('@/views/pages/Login.vue'),
    meta: { title: 'Menute - Companies Login' },
  },
  {
    path: basePath + 'password-reset/:token',
    name: 'PasswordReset',
    component: () => import('@/views/pages/PasswordReset.vue'),
    meta: { title: 'Menute - Companies Password Reset' },
  },
  {
    path: basePath + 'forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/pages/ForgotPassword.vue'),
    meta: { title: 'Menute - Companies Forgot Password' },
  },
  {
    path: basePath,
    name: 'Home',
    component: DefaultLayout,
    redirect: basePath + 'dashboard',
    meta: { middleware: [auth], title: 'Menute - Companies Home' },
    children: [
      {
        path: basePath + 'dashboard',
        name: 'Dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
      },

      {
        path: basePath + 'users',
        name: 'Users',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/users/List.vue'),
      },

      {
        path: basePath + 'invoices',
        name: 'Invoices',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: basePath + 'invoices/list',

        children: [
          {
            path: basePath + 'invoices/list',
            name: 'Invoice List',
            component: () => import('@/views/invoice/List.vue'),
          },
          {
            path: basePath / 'invoices/:id/details',
            name: 'InvoiceDetails',
            component: () => import('@/views/invoice/Details.vue'),
          },
        ],
      },

      {
        path: basePath + 'reports',
        name: 'Reports',
        component: () => import('@/views/reports/List.vue'),
      },

      {
        path: basePath + 'groups',
        name: 'Groups',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: basePath + 'groups/list',
        children: [
          {
            path: basePath + 'groups/new',
            name: 'New',
            component: () => import('@/views/budget/Form.vue'),
          },
          {
            path: basePath + 'groups/list',
            name: 'List',
            component: () => import('@/views/budget/List.vue'),
          },
          {
            path: basePath + 'groups/:id/users',
            name: 'Group Users',
            component: () => import('@/views/budget/Users.vue'),
          },
          {
            path: basePath + 'groups/:id/details',
            name: 'Group Details',
            component: () => import('@/views/budget/Form.vue'),
          },
        ],
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory('/'),   // or simply: createWebHistory()
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})


router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index]

  if (!subsequentMiddleware) return context.next

  return (...parameters) => {
    context.next(...parameters)

    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware]

    const context = {
      from,
      next,
      router,
      to,
    }
    const nextMiddleware = nextFactory(context, middleware, 1)

    return middleware[0]({ ...context, next: nextMiddleware })
  }

  return next()
})

export default router
